import React from 'react';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Input,
  Box,
  Text,
} from '@chakra-ui/react';

const DaysTimeTable = ({ schedule, onScheduleChange }) => {
  const daysOfWeek = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
  ];

  const handleTimeChange = (day, field, value) => {
    const updatedSchedule = {
      ...schedule,
      [day]: { ...schedule[day], [field]: value },
    };
    onScheduleChange(updatedSchedule);
  };

  return (
    <Box overflowX="auto">
      <Table variant="simple">
        <Thead>
          <Tr>
            <Th colSpan="3" textAlign='center' width='100%'>
              <Text fontWeight={"900"} color="black">weekly schedule</Text>
            </Th>
          </Tr>
          <Tr>
            <Th>Day</Th>
            <Th>Start Time</Th>
            <Th>End Time</Th>
          </Tr>
        </Thead>
        <Tbody>
          {daysOfWeek.map((day) => (
            <Tr key={day}>
              <Td>
                <Text textTransform="capitalize">{day}</Text>
              </Td>
              <Td>
                <Input
                  type="time"
                  value={schedule[day]?.start_time || ''}
                  onChange={(e) =>
                    handleTimeChange(day, 'start_time', e.target.value)
                  }
                />
              </Td>
              <Td>
                <Input
                  type="time"
                  value={schedule[day]?.end_time || ''}
                  onChange={(e) =>
                    handleTimeChange(day, 'end_time', e.target.value)
                  }
                />
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

export default DaysTimeTable;
